var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation4315546(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.961,
    height: 20,
    viewBox: "0 0 14.961 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "location_4315546",
    d: "M71.98,0A7.489,7.489,0,0,0,64.5,7.48a10.79,10.79,0,0,0,1.93,5.184c1.078,1.781,2.414,3.551,3.59,5.109.543.719,1.055,1.4,1.449,1.961a.626.626,0,0,0,1.023,0c.395-.562.906-1.242,1.449-1.961,1.176-1.559,2.508-3.328,3.59-5.109a10.79,10.79,0,0,0,1.93-5.184A7.489,7.489,0,0,0,71.98,0Zm0,10.938A3.457,3.457,0,1,1,75.438,7.48,3.461,3.461,0,0,1,71.98,10.938Z",
    transform: "translate(-64.5)",
    fill: "#7d96ff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation4315546);
export default __webpack_public_path__ + "static/media/location_4315546.434dcc041c5b998e971da7b0ed6ad0f9.svg";
export { ForwardRef as ReactComponent };